/**
 * Labstep
 *
 * @module components/File/Action/Remove
 * @desc Action to remove a file from parent
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { Metadata } from 'labstep-web/models/metadata';
import type React from 'react';
import type { FileActionRemoveProps } from './types';

const defaultActionComponentProps = {
  type: 'icon',
  popup: {},
  icon: 'close',
} as ActionComponentProps;

export const FileActionRemove: React.FC<FileActionRemoveProps> = ({
  file,
  createProps,
  actionComponentProps: customActionComponentProps,
  options,
}) => {
  if (file.parent_type !== Metadata.entityName) {
    return null;
  }
  const actionComponentProps = {
    ...defaultActionComponentProps,
    ...customActionComponentProps,
  } as ActionComponentProps;

  return createProps ? (
    <EntityActionCreate
      parentName={createProps.parentName}
      parentId={createProps.parentId}
      entityName={Metadata.entityName}
      body={{ ...createProps.createBody, file_id: null }}
      actionComponentProps={actionComponentProps}
      options={options}
    />
  ) : (
    <EntityActionUpdate
      entityName={file.entityName}
      id={file.id}
      body={{
        [`${file.parent_type}_id`]: null,
      }}
      actionComponentProps={actionComponentProps}
      options={options}
    />
  );
};
